const statuses = state => state.statuses
const appointmentPreferences = state => state.appointmentPreferences
const simptomsOptions = state => state.simptomsOptions
const genderOptions = state => state.genderOptions
const statusesById = state => {
  let statuses = JSON.parse(JSON.stringify(state.statuses))

  return statuses.reduce((object, item) => {
    return {
      ...object,
      [item[item.id]]: item.name,
    }
  }, {})
}

export default {
  statuses,
  statusesById,
  appointmentPreferences,
  simptomsOptions,
  genderOptions
}
